export const INSTAGRAM_URL = "https://www.instagram.com/raiz.mandioca/";
export const SHOP_URL = "https://shop.raizfoods.nl/";
